import React, {MutableRefObject} from 'react';
import './_select-fabric.scss';

import {IS_SOLID, IS_WALLPAPER} from '../../../../constants/Products';
import {translate} from '../../../../services';
import {ProductTypeAbbreviated} from '../../../../shapes/products';
import {RefScrollIntoView} from '../../../../shapes/refScroll';
import {objectIsNotEmpty} from '../../../../utils/validation';
import Icon from '../../../Reusable/Icon/Icon';


export interface SelectFabricProps {
  fabricList: string[];
  selectedSubstrate: string;
  openFabricPreferencesModal?: () => void;
  wallpaperType?: string;
  productInfoRef?: MutableRefObject<HTMLButtonElement & RefScrollIntoView | null>;
  openWallpaperCalculatorModal?: () => void;
  designNotPurchasable?: boolean;
  productAvailable?: boolean;
  outOfStock?: boolean;
  productTypeAbbreviated?: ProductTypeAbbreviated;
}

const SelectFabric = ({
  fabricList, openFabricPreferencesModal, selectedSubstrate, outOfStock, wallpaperType, productInfoRef,
  openWallpaperCalculatorModal, designNotPurchasable, productAvailable, productTypeAbbreviated
}: SelectFabricProps): JSX.Element => {
  const allowFabricEdit = fabricList.length > 1;

  function handleMoreClick() {
    (objectIsNotEmpty(productInfoRef) && productInfoRef.current) &&
    productInfoRef.current.scrollIntoView({
      behavior: 'smooth'
    });
  }

  const renderCalculatorLink = () => (
    <button className='wallpaper-calculator-btn x-non-full-width-mobile-button' onClick={openWallpaperCalculatorModal} type='button'>
      <Icon iconName='ruler-horizontal' extensionClass='header-icon' />
      <span className='wallpaper-calculator-btn-text'>
        <span className='x-emphasis'>{translate('wallpaperCalculator.calculatorButtonTextOne')}</span> {translate('wallpaperCalculator.calculatorButtonTextTwo')}
      </span>
    </button>
  );

  return (
    <section className='b-select-fabric detail-section'>
      <h3 className='h2' itemProp='category'>{wallpaperType ? translate('wallpaper.head.title') : translate('fabric.headlines.fabric')}</h3>
      {allowFabricEdit ?
        <React.Fragment>
          <button className={`substrate-link ${outOfStock ? 'out-of-stock-dropdown' : null}`} onClick={openFabricPreferencesModal} type='button'>
            <span className='substrate-name' itemProp='material'>{translate(`fabricShop.${selectedSubstrate}.name`)}</span>
            <Icon iconName='chevron-down' iconTitle={translate('fabricShop.changeSubstrate')}/>
          </button>
          {outOfStock && <p className='out-of-stock-message'>{wallpaperType ? translate('wallpaper.outOfStock.message') : translate('fabric.outOfStock.message')}</p>}
        </React.Fragment> :
        <React.Fragment>
          <h3 className='substrate-name' itemProp='material'>
            {IS_SOLID(productTypeAbbreviated) ? translate(`solidFabrics.${selectedSubstrate}.name`) : translate(`fabricShop.${selectedSubstrate}.name`)}
          </h3>
          {IS_SOLID(productTypeAbbreviated) &&
          <React.Fragment>
            <p className='link-wrapper'>
              (<button
                type='button'
                onClick={handleMoreClick}
                className='fabric-detail-link x-non-full-width-mobile-button'>
                {translate('fabric.aboutFabric.learnMore')}
                <Icon iconName='arrow-down'/>
              </button>)
            </p>
          </React.Fragment>}
          {outOfStock && <p className='out-of-stock-message'>{wallpaperType ? translate('wallpaper.outOfStock.messageShort') : translate('fabric.outOfStock.messageShort')}</p>}
        </React.Fragment>
      }
      {(IS_WALLPAPER(productTypeAbbreviated) && !designNotPurchasable && productAvailable) && renderCalculatorLink()}
    </section>
  );
};

export default SelectFabric;
